const userInteractionEvent = (label, action, category) => ({
  event: 'user_interactions',
  user_event_label: label,
  user_event_action: action,
  user_event_category: category,
});

export default userInteractionEvent;
